import React, { useEffect, useState } from "react";
import { Text } from "../../talent.styled";
import { useTranslation } from "react-i18next";


const TranslatedText: React.FC<{translate?: boolean, className?: string}> = ({
  translate,
  className,
  children: sourceText,
}) => {
  const [translatedText, setTranslatedText] = useState<string>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if(!translate){
      setTranslatedText(sourceText as string);
      return;
    }

    const text: string = sourceText as string;
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=pt-br&tl=${i18n.language}&dt=t&q=${encodeURI(text)}`;
    fetch(url).then((response) => {
      response.json().then((data) => {
        if(Array.isArray(data[0])){
          const content: string = data[0].map((item: any) => item[0]).join('');
          setTranslatedText(content);
        }
      });
    });
    
  }, [i18n.language, sourceText, translate]);

  return (
    <Text className={className}>
      {translatedText}
    </Text>
  );
};

export default TranslatedText;
